import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAsync } from 'react-use';
import { travelRequirementsService } from '../../../services';
import { DocumentInfoCountry } from './DocumentInfoCountry';
import { Box, Typography } from '@material-ui/core';
import { TravelRequirementsReqSchema } from '../TravelRequirementsReqSchema';
import { BackdropProgress } from '../../../components';
import { useTranslation } from 'react-i18next';
import { format, startOfToday, addDays } from 'date-fns';

RequirementsInfo.propTypes = {};

function RequirementsInfo({ formData }) {
  const { t } = useTranslation();

  const isValidReq = TravelRequirementsReqSchema.isValidSync(formData);
  const { loading, value: travelDocsInfo, error } = useAsync(async () => {
    const requestBody = { ...formData };
    if (requestBody && requestBody.transitAirports) {
      requestBody.transitAirports = requestBody.transitAirports.map(
        (airport) => airport.code
      );
    }

    // Hardcoded arrivalDate and passport type
    requestBody.arrivalDate = format(addDays(startOfToday(), 1), 'yyyy-MM-dd');
    requestBody.documentType = 'passport';

    return travelRequirementsService.getTravelRequirements(requestBody);
  }, [formData]);

  if (!formData || !isValidReq) {
    return <Typography color="error">Search parameters are invalid</Typography>;
  }

  if (error) {
    return (
      <Typography color="error">
        Something went wrong. Please try again after sometime.
      </Typography>
    );
  }

  return (
    <>
      {travelDocsInfo &&
        travelDocsInfo.map((documentInfo, index) => {
          const { countryName } = documentInfo;
          return (
            <Box key={index} marginTop={3}>
              <Typography variant="h6" color="primary">
                {index === 0
                  ? t('originCountryHeader', { countryName })
                  : t('transitCountryHeader', { countryName })}
              </Typography>
              <DocumentInfoCountry documentInfo={documentInfo} />
            </Box>
          );
        })}
      <BackdropProgress show={loading} />
    </>
  );
}

export default RequirementsInfo;
